import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import Select from 'react-select'
import PropTypes from 'prop-types'

import { ACL } from '../../../../constants'
import { getEstates, getSelectedEstate } from '../../../../reducers/app'
import { EstateUtils } from '../../../../utils'

import './EstateSwitcher.scss'

const EstateSwitcher = ({ onChangeEstate }) => {
    const selectedEstate = useSelector(getSelectedEstate) || {}
    const { t } = useTranslation()
    const [selectedOption, setSelectedOption] = useState({
        value: selectedEstate.id,
        label: selectedEstate.name,
    })
    const options = useSelector((state) => {
        const estates = getEstates(state)

        return (
            estates
                // Filter out hidden estates when user doesn't have permission to see them
                .filter(({ id: estate, isHidden }) => {
                    const canSeeEstate =
                        !isHidden ||
                        EstateUtils.hasPermission(
                            state,
                            {
                                acls: [ACL.VIEW_HIDDEN_ESTATES],
                            },
                            { estate }
                        )
                    return canSeeEstate
                })
                // Sort by ordering numbers
                .sort(({ order: order1 = Number.MAX_SAFE_INTEGER }, { order: order2 = Number.MAX_SAFE_INTEGER }) => order1 - order2)
                // Extract values and labels
                .map(({ name, id }) => {
                    return {
                        value: id,
                        label: name,
                    }
                })
        )
    })

    // Selected option only changes when selectedEstate changes
    useEffect(() => {
        setSelectedOption({
            value: selectedEstate.id,
            label: selectedEstate.name,
        })
    }, [selectedEstate.id, selectedEstate.name])

    /**
     * On estates dropdown change
     * @param {Object} o
     * @param {String} o.value
     */
    const onChange = (o) => {
        onChangeEstate(o.value)
    }

    return (
        <>
            <Select className="estate-switcher" options={options} onChange={onChange} value={selectedOption} placeholder={t('select-estate')} />
        </>
    )
}

EstateSwitcher.propTypes = {
    onChangeEstate: PropTypes.func,
}

EstateSwitcher.defaultProps = {
    onChangeEstate: () => null,
}

export default EstateSwitcher
